import { store } from '~state/ReduxWrapper';
import {
  handleSubmitError,
  prepareDataForSubmit,
} from '~components/forms/SubmissionHelpers';
import axios from '~utils/axios';
import formatDate from '~utils/formatDate';
import { navigate } from 'gatsby';
import updateDataLayer from '~utils/events';

export function getFieldsForReferral(person, absenteeFields) {
  return prepareDataForSubmit({
    first_name: person.first_name,
    last_name: person.last_name,
    address1: person.address1,
    address2: person.address2,
    city: person.city,
    state: person.state,
    phone: person.phone,
    zipcode: person.zipcode,
    year_of_birth: person.year_of_birth,
    month_of_birth: person.month_of_birth,
    day_of_birth: person.day_of_birth,
    email: person.email,
    sms_opt_in_subscriber: absenteeFields.sms_opt_in_subscriber,
    sms_opt_in_voteamerica: absenteeFields.sms_opt_in_voteamerica,
    referring_tool: 'absentee',
  });
}

export function postCompletionToTurnout(tool) {
  const { person, sourcing, absenteeFields, pavFields } = store.getState();
  const fields = tool === 'pav' ? pavFields : absenteeFields;
  const { subscriber } = sourcing;
  const today = new Date();

  const params = {
    referring_tool: fields.referring_tool,
    uuid: fields.uuid,
    region: fields.region,
    state: person.state,
    submit_date: formatDate(
      today.getFullYear(),
      today.getMonth() + 1,
      today.getDate()
    ),
    state_fields: {},
  };

  const submitData = prepareDataForSubmit(params);

  const patchPath = tool === 'pav' ? 'pav/signup/' : 'absentee/request/';

  try {
    axios.patch(
      `${patchPath}${params.uuid}/?subscriber=${subscriber}`,
      submitData
    );
  } catch (error) {
    handleSubmitError(error, params, null);
  }
}

export function sendAbsenteeForm(isFollowUp = false, tool = 'absentee') {
  const { person, absenteeFields, pavFields } = store.getState();
  const fields = tool === 'pav' ? pavFields : absenteeFields;

  try {
    postCompletionToTurnout(tool);

    const fieldsUpdate = { ...fields, formRequested: true };

    store.dispatch({
      type: `${tool.toUpperCase()}_UPDATE_FIELDS`,
      absenteeFields: fieldsUpdate,
    });

    const event = isFollowUp ? 'action-follow-up' : 'action-finish';

    updateDataLayer({
      event,
      method: 'pdf',
      tool,
      state: person.state,
      first_name: person.first_name,
      last_name: person.last_name,
      email: person.email,
      zipcode: person.zipcode,
      url: undefined,
    });

    navigate(`/tools/${tool}/download-pdf/`);
  } catch (error) {
    handleSubmitError(error, null, null);
  }
}

export function completeAbsenteeForIneligibleState(
  tool = 'absentee',
  nextPage = 'ineligible-state'
) {
  const { person } = store.getState();

  try {
    postCompletionToTurnout(tool);

    updateDataLayer({
      event: 'action-finish',
      method: 'ineligible-state',
      tool,
      state: person.state,
      first_name: person.first_name,
      last_name: person.last_name,
      email: person.email,
      zipcode: person.zipcode,
      url: undefined,
    });

    navigate(`/tools/${tool}/${nextPage}/`);
  } catch (error) {
    handleSubmitError(error, {}, null);
  }
}
